import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ResponcePage } from 'projects/core/src/lib/misc/data/responce-page';
import { Project } from './project';

@JsonObject('ProjectResponcePage')
export class ProjectResponcePage extends ResponcePage {

	@JsonProperty([Project], 'content')
	content: Project[];
}